export default {
  'welcome.header.greeting': '👋 Hi, {name}',
  'welcome.header.title': 'Your AI works. Now ship it.',
  'welcome.header.subtitle':
    'Take chatbots, AI assistants, and smart agents from demo to production in minutes.',
  'welcome.card.blank.title': 'Start from Scratch',
  'welcome.card.blank.desc': 'Begin with a clean slate and full control',
  'welcome.card.template.title': 'Browse Templates',
  'welcome.card.template.desc': 'Jumpstart your project with pre-built logic',
  'welcome.copilot.placeholder':
    "What's on your mind? Tell Copilot to start weaving...",
  'welcome.apps.title': 'Explore Featured Agents',
  'welcome.apps.minecraft': 'Minecraft Agent',
  'welcome.apps.tags.react': 'React',
  'welcome.apps.tags.roleplay': 'Role-play',
};
